import packageJson from '../../../package.json';

export const AppInfo = {
  name: packageJson.name,
  displayName: packageJson['display-name'],
  version: packageJson.version,
};
export type AppInfoSet = typeof AppInfo;

console.log(`%cWelcome to turn2me! [ Version ${AppInfo.version} ] ✨`, 'color: #009FE3')
console.log(`%cApp Designed & Developed by Threadable. [https://threadable.io]`, 'color: #009FE3')
